<template>
  <div id="app">
    <app-header></app-header>
    <router-view/>
  </div>
</template>

<script>
import AppHeader from "@/components/Header";

export default {
  data() {
    return {
      loading: null
    };
  },
  watch: {
    isFetching: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$log.info("[app] -> is fetching");

          setTimeout(() => {
            if (this.isFetching) {
              this.$log.info("[app] -> fetching since 500ms, show loader");
              this.loading = this.$loading({
                lock: true
              });
            }
          }, 500);
        } else if (!val && this.loading) {
          this.loading.close();
        }
      }
    }
  },
  computed: {
    isFetching() {
      return this.$store.state.isFetching;
    }
  },
  // created() {
  //   this.$el.style.setProperty("--primary-color", "#1995dc");
  // },
  created() {},
  components: {
    AppHeader
  }
};
</script>

<style lang="scss">
// @import url("https://fonts.googleapis.com/css?family=Sarabun:400,500,600,700,800");
@import url("https://fonts.googleapis.com/css?family=Yantramanav:400,500,700,900");
@import url("https://fonts.googleapis.com/css?family=Roboto:400,500,700,900");

#app {
  height: 100vh;
  background: $--color-app-bg;
  display: flex;
  flex-direction: column;
}

.area-header {
  margin: 30px 0;
}

.fullpage {
  height: 100vh;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
